import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/api/client'
import type { ListPoolResponse, ProvisionIpsRequest, ProvisionIpsResponse } from '@/api/types'
import { queryKeys, type IpPoolFilters } from '@/lib/queryKeys'

export function useIpPool(filters?: IpPoolFilters) {
  return useQuery({
    queryKey: queryKeys.ipPool.list(filters),
    queryFn: () => api.get<ListPoolResponse>('/admin/ip-pool', filters as Record<string, string | undefined>),
  })
}

export function useProvisionIps() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: ProvisionIpsRequest) =>
      api.post<ProvisionIpsResponse>('/admin/ip-pool/provision', data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.ipPool.all })
    },
  })
}

export function useRemovePoolIp() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => api.delete<string>(`/admin/ip-pool/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.ipPool.all })
    },
  })
}
